export default __webpack_public_path__ + "img/look.7a421980.svg";